import type { NavigationGuard } from 'vue-router';
import { request } from '@/api/request';
import { withTransientRetry } from '@/modules/query/utils';
import type { AnswerSet } from '@@/packages/shared/types/models/answerSet';

/**
 * Opens an answer set only on its own supplier's profile, and sends anything
 * else back to the profile's Assessment tab before any of the route's views
 * render. The path carries the supplier and the set separately, so a
 * hand-edited URL can pair one supplier's profile with another's set; the
 * backend allows the read, because the set itself is the caller's.
 */
export const requireAnswerSetOfSupplier: NavigationGuard = async (to, _from, next) => {
  const { id, answerSetID } = to.params;
  const assessmentTab = { name: 'suppliers-profile-assessment', params: { id } };
  if (typeof answerSetID !== 'string') return next(assessmentTab);
  try {
    const { data: answerSet } = await withTransientRetry(() =>
      request<AnswerSet>('GET', `/assessments/answer-sets/${answerSetID}`),
    );
    return answerSet.supplierID === id ? next() : next(assessmentTab);
  } catch {
    return next(assessmentTab);
  }
};
